import { news } from '@/configs/translates.config'
export default {
	'add-new-news': `add new ${news.en.singular}`,
	'the-news': `the ${news.en.singular}?`,
	news: news.en.singular,
}